import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FsOrgState, LoadingState, NewsState } from '../../../reducers';
import { NewsActions, NewsActionTypes } from './news.actions';

const initialState: NewsState = {
  newsToRead: null,
  feed: null,
  feedState: LoadingState.INIT,
  readNewsVisibles: false,
};

export function NewsReducer(state: NewsState = initialState, action: NewsActions = null): NewsState {
  switch (action.type) {
    case NewsActionTypes.LoadNewsSuccess: {
      return {
        ...state, feed: action.payload.response, newsToRead: action.payload.newsToRead, feedState: LoadingState.LOADED,
      };
    }

    case NewsActionTypes.LoadNewsFailure: {
      return { ...state, feedState: action.payload.response.error };
    }

    default: {
      return state;
    }
  }
}

export const newsFeature = createFeatureSelector<FsOrgState, NewsState>('news');

export const newsToRead = createSelector(
  newsFeature,
  (state: NewsState) => state.newsToRead,
);

export const feed = createSelector(
  newsFeature,
  (state: NewsState) => ({
    collection: state.feed,
    state: state.feedState,
  }),
);
